import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpParamNames } from 'src/app/core/constantes/http_param-names';
import { PredefinedFilter } from 'src/app/models/predefined-filter';
import { Results } from 'src/app/models/server/core/results-T';
import { ConnectedUsersStateService } from '../state/connected-users-state.service';
import { ViewsStateService } from '../state/views-state.service';
import { ServiceBase } from './service-base';

@Injectable({
    providedIn: 'root',
})
export class PredefinedFiltersService extends ServiceBase {
    constructor(
        private http: HttpClient,
        public override connectedUserStateService: ConnectedUsersStateService,
        private viewsStateService: ViewsStateService
    ) {
        super(connectedUserStateService);
    }

    /**
     * Liste les filtres prédéfinis
     */
    public List(viewId: number): Observable<PredefinedFilter[]> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                sort: this.getHeader(null),
                filters: this.getHeader([]),
                context: this.getHeader(null),
            }),
            params: new HttpParams().set(HttpParamNames.FROM, '0').set(HttpParamNames.SIZE, '1000'),
        };

        // Appel de la Web Api
        return this.http.get(this.baseUrl + `/api/organizations/${this.organizationId}/views/${viewId}/predefined-filters`, httpOptions).pipe(
            map((x) => {
                var res = Results.getCopyFrom<PredefinedFilter>(PredefinedFilter, x);

                return res.value;
            })
        );
    }

    /**
     * Récupère le filtre prédéfini correspondant à un id.
     * @param predefinedFilterId Id du filtre prédéfini.
     * @returns le filtre prédéfini.
     */
    public get(predefinedFilterId: number): Observable<PredefinedFilter> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        };
        return this.http
            .get<PredefinedFilter>(
                this.baseUrl +
                    `/api/organizations/${this.userConnected.organization.id}/views/${this.viewsStateService.getSelectedView().id}/predefined-filters/${predefinedFilterId}`,
                httpOptions
            )
            .pipe(
                map((x) => {
                    let instance = new PredefinedFilter();
                    instance.copyFrom(x);
                    return instance;
                })
            );
    }

    /**
     * Met à jour un filtre prédéfini.
     * @param predefinedFilter Instance du filtre prédéfini.
     */
    public update(predefinedFilter: PredefinedFilter): Observable<PredefinedFilter> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        };

        return this.http
            .put<PredefinedFilter>(
                this.baseUrl + `/api/organizations/${this.organizationId}/views/${this.viewsStateService.getSelectedView().id}/predefined-filters/${predefinedFilter.id}`,
                predefinedFilter.toServerRepresentation(),
                httpOptions
            )
            .pipe(
                map((x) => {
                    let instance = new PredefinedFilter();
                    instance.copyFrom(x);
                    return instance;
                })
            );
    }

    /**
     * Supprime un filtre défini.
     * @param predefinedFilterId Identifiant du filtre prédéfini.
     */
    public delete(predefinedFilterId: number): Observable<boolean> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        };

        return this.http
            .delete<PredefinedFilter>(
                this.baseUrl + `/api/organizations/${this.organizationId}/views/${this.viewsStateService.getSelectedView().id}/predefined-filters/${predefinedFilterId}`,
                httpOptions
            )
            .pipe(
                map((x) => {
                    return true;
                })
            );
    }

    /**
     * Crée un filtre prédéfini.
     * @param predefinedFilter Instance du filtre prédéfini.
     */
    public add(predefinedFilter: PredefinedFilter): Observable<PredefinedFilter> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        };

        predefinedFilter.organizationId = this.organizationId;
        return this.http
            .post<PredefinedFilter>(
                this.baseUrl + `/api/organizations/${this.organizationId}/views/${this.viewsStateService.getSelectedView().id}/predefined-filters`,
                predefinedFilter.toServerRepresentation(),
                httpOptions
            )
            .pipe(
                map((x) => {
                    let instance = new PredefinedFilter();
                    instance.copyFrom(x);
                    return instance;
                })
            );
    }
}
